// src\components\Payroll\PartialSalaryFld\PartialSalary.js
import React, { useState, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";

import {
  CreateTableNew as CreateTable,
  SearchBar,
  Button,
  GeneralMessage,
  useGeneralMessage,
} from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";

import { usePartialSalary } from "./shared/usePartialSalary";
import { PartialSalaryModal } from "./shared/PartialSalaryModal";

function PartialSalary({ user, isHideSideMenu }) {
  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  const {
    loading,
    requestLoading,
    data,
    options,
    handleAdd,
    handleUpdate,
    handleFilter,
  } = usePartialSalary({ user, showGeneralMessage });

  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("add");
  const [selectedData, setSelectedData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const openModal = (item = null, formMode = "add") => {
    setSelectedData(item);
    setMode(formMode);
    setShowModal(true);
  };

  // ── Table config ──────────────────────────────────────────────────────────
  const headers = [
    "ID",
    "Amount",
    "Employee Type",
    "Position",
    "Status",
    "Actions",
  ];
  const accessors = [
    "id",
    "amount",
    "employeeTypeDescription",
    "positionDescription",
    "isActiveDisplay",
    "actions",
  ];

  const actions = [
    {
      name: "Edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: (item) => openModal(item, "edit"),
      visible: true,
    },
  ];

  const renderCustomCell = (row, accessor) => {
    if (accessor === "isActiveDisplay") {
      return row.isActive ? (
        <span className="rounded-full bg-green-100 px-2 py-1 text-xs text-green-800">Active</span>
      ) : (
        <span className="rounded-full bg-red-100 px-2 py-1 text-xs text-red-800">Inactive</span>
      );
    }
    return null;
  };

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace" />
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <div className="MainteInfo shadow-xl">
          <div className="mainteHeader">
            <div className="sub-title row">
              <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Maintenance > "}</span>
              <span style={{ borderBottom: "1px solid black" }}>{"Partial Salary"}</span>
            </div>
            <h3>Partial Salary</h3>
          </div>

          <div className="space-y-4 p-4">
            <SearchBar handleFilter={handleFilter} />

            <Button
              icon={<AddIcon />}
              name="Add Partial Salary"
              className="bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"
              onClick={() => openModal(null, "add")}
            />

            <CreateTable
              tableName="PartialSalaryTable"
              headers={headers}
              accessors={accessors}
              data={data}
              actions={actions}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              itemsPerPage={10}
              totalItems={data?.length}
              customCellRenderer={renderCustomCell}
            />
          </div>
        </div>
      </div>

      <PartialSalaryModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        mode={mode}
        selectedData={selectedData}
        options={options}
        onAdd={handleAdd}
        onUpdate={handleUpdate}
      />

      <GeneralMessage form={showMessage} message={message} isSuccess={isSuccess} />
      <LoadingSpinner loading={loading || requestLoading} />
    </div>
  );
}

export default PartialSalary;